import {Plugin} from 'prosemirror-state';

/**
 * A Plugin which intercepts the paste event for text.
 *
 */
export const pasteYoutubeEmbedPlugin = new Plugin({
  props: {
    handlePaste(view, event) {
      let text = event.clipboardData?.getData('text/plain') || '';

      if (!isYoutubeLink(text)) {
        return false;
      }

      const {schema, tr} = view.state;

      const youtubeId = parseYoutubeId(text);
      const startTime = parseStartTime(text);

      const embedNode = schema.nodes.youtube_embed.create({videoId: youtubeId, startTime});

      // Paste the plain text
      tr.replaceSelectionWith(embedNode);

      view.dispatch(tr);

      return true; // Prevent default pasting behavior
    },
  },
});

function isYoutubeLink(str: string) {
  try {
    const url = new URL(str);

    // Check for YouTube domains
    if (!['youtube.com', 'www.youtube.com', 'youtu.be'].includes(url.hostname)) {
      return false;
    }

    // Handle youtu.be short links
    if (url.hostname === 'youtu.be') {
      return url.pathname.length > 1; // At least has a video ID
    }

    // Handle regular youtube.com links
    if (url.pathname.startsWith('/watch')) {
      return url.searchParams.has('v');
    }

    // Handle youtube.com/embed links
    if (url.pathname.startsWith('/embed/')) {
      return url.pathname.length > 7; // "/embed/" is 7 chars
    }

    // Handle youtube.com/shorts links
    if (url.pathname.startsWith('/shorts/')) {
      return url.pathname.length > 8; // "/shorts/" is 8 chars
    }

    return false;
  } catch (e) {
    return false;
  }
}

function parseYoutubeId(text: string) {
  const url = new URL(text);

  // Handle youtu.be short links
  if (url.hostname === 'youtu.be') {
    return url.pathname.slice(1); // Remove leading '/'
  }

  // Handle regular youtube.com links
  if (url.hostname === 'youtube.com' || url.hostname === 'www.youtube.com') {
    if (url.pathname.startsWith('/watch')) {
      return url.searchParams.get('v');
    } else if (url.pathname.startsWith('/embed/')) {
      return url.pathname.slice(7); // Remove "/embed/"
    } else if (url.pathname.startsWith('/shorts/')) {
      return url.pathname.slice(8); // Remove "/shorts/"
    }
  }

  return null;
}

function parseStartTime(text: string) {
  const url = new URL(text);

  // Check if the URL has a start time parameter
  if (url.searchParams.has('t')) {
    const timeStr = url.searchParams.get('t');
    if (!timeStr) return null;
    const timeParts = timeStr.split(':');

    let seconds = 0;
    for (let i = 0; i < timeParts.length; i++) {
      seconds += parseInt(timeParts[i], 10) * Math.pow(60, timeParts.length - i - 1);
    }
    return seconds;
  }

  return null;
}
